import * as types from '../actions';

const initialState = {
    activity:'',
    data:'' 
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        
        case types.LOGOUT_USER_SUCCESS:
            if(response.status){
                return {
                    ...state,
                    activity:types.LOGOUT_USER_SUCCESS,   
                    data:response.data,
                    status:response.status
                }     
            }else{
                return {
                    ...state,                  
                    activity:types.LOGOUT_USER_ERROR,   
                    status:response.status      
                }   
            } 
        case types.CLEAR:
            return {
                ...state,
                data:'',
                activity:types.CLEAR
            }             

        default:
            return state;
    }
};